import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProjectsSchemaIcon } from '@repo/custom-icons';
import { Card, CardContent } from '@repo/ui-primitives/card';
import { cn } from '@repo/ui-primitives/utils';
export function EmptyProjectList(param) {
    let { title, className } = param;
    return /*#__PURE__*/ _jsx(Card, {
        className: cn('flex min-h-[200px] items-center justify-center border-dashed', className),
        children: /*#__PURE__*/ _jsxs(CardContent, {
            className: "flex flex-col items-center justify-center gap-4",
            children: [
                /*#__PURE__*/ _jsx(ProjectsSchemaIcon, {
                    className: "text-turquoise-500",
                    width: 64,
                    height: 64
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-center text-base text-muted-foreground",
                    children: title !== null && title !== void 0 ? title : 'There are currently no projects added'
                })
            ]
        })
    });
}
